<template>
  <div v-if="unavailable" class="unavailable-preview">
    <div class="text px-4">
      <v-icon class="mb-2" color="cinza-l20" large>mdi-email</v-icon>
      <div class="title">Confira o conteúdo do e-mail em Detalhes do canal</div>
    </div>
  </div>
  <div v-else class="message-bubble">
    <span class="message-text">
      <div v-if="messageTitle">
        <span class="font-weight-bold" v-html="messageTitle" />
        <br />
      </div>
      <span v-html="parsedMessage" />
    </span>
  </div>
</template>

<script>
import { variablesInspection } from '@/modules/maria/campanha-da-maria-v2/mixins/variables-inspection.js'

export default {
  name: 'ChannelMessagePreview',
  mixins: [variablesInspection],
  props: {
    messageTitle: {
      type: String,
      default: '',
    },
    unavailable: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.unavailable-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f2f2;
  border-radius: 16px;
  min-height: 120px;
  height: 100%;
  width: 100%;
  .text {
    display: flex;
    flex-direction: column;
    align-items: center;
    .v-icon {
      font-size: 24px !important;
    }
    .title {
      color: #6b7580;
      font-family: Lato !important;
      text-align: center;
      font-size: 16px !important;
      font-weight: 400;
      line-height: 20px;
    }
  }
}
.message-bubble {
  height: auto;
  max-height: 160px;
  background: #f2f2f2;
  border-radius: 16px;
  padding: 8px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
}
.message-text {
  font-size: 13px;
  color: #333;
  letter-spacing: 0.4000000059604645px;
  overflow-wrap: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  line-clamp: 7;
  -webkit-box-orient: vertical;
}
::v-deep .variable-style {
  font-weight: bold;
  white-space: nowrap;
  color: #9747ff;
}
::v-deep .subvariable-style {
  font-weight: bold;
  white-space: nowrap;
  color: $cinza-d20;
}
</style>
